const theme = {
  palette: {
    primary: '#F47D25',
    lightPrimary: '#4cb1e8',
    secondary: '#82D4D9',
    loadingBackgroundColor: '#2c3e51cc',
    color: ['#e64c38', '#06AEBA', '#f8b51d'],
    dark: '#000444',
  },
  fonts: {
    primary: 'Roboto',
  },
  fontWeight: {
    thin: 100, // Thin
    utraLight: 200, // Ultra Light
    light: 300, // Light
    regular: 400, // Regular
    medium: 500, // Medium
    semibold: 600, // Semibold
    bold: 700, // Bold
    heavy: 800, // Heavy
    black: 900, // Black
  },
  background: {
    primary: '#06AEBA',
    warning: '#f8b51d',
    error: '#ed1558',
    content: '#fff',
    container: '#f4f7f9',
    input: '#efeff0',
    disabled: '#969696',
    headerTable: '#ffff',
    gray: '#f0f0f0',
    light: '#e4e7eb',
  },
  text: {
    primary: '#1f2933',
    text: '#1f2933',
    lightPrimary: '#3e4c59',
    secondary: '#a4a4a4',
    tabTitle: '#7f817c',
    empty: '#969696',
    highlight: '#5d4ec2',
    disabled: '#969696',
    formLabel: '#1f2933',
    headerTable: '#0f100d',
    note: '#878787',
    formIcon: '#41433f',
  },
  border: {
    default: '#dddddd',
    light: '#e4e7eb',
    primary: '#06AEBA',
  },
  scrollbar: {
    thumb: '#b7b6c2',
    track: '#f0f3fa',
  },
  color: {
    gray: '#a3a3a3',
    green: '#4fcea2',
    brightGreen: '#52c41a',
    red: '#e64c38',
    blue: '#0992d0',
    orange: '#f5a623',
    darkOrange: '#f67800',
    pink: '#F75D81',
    limeGreen: '#4fcea2',
    lightGreen: '#3ebac2',
    blueShade: '#2d7fd3',
    yellow: '#FFCA28',
    violet: '#665ca7',
    purple: '#ac009f',
  },
  alert: {
    error: 'red',
  },
  card: {
    header: '#d4d2f450',
  },
  sidebar: {
    activeText: 'white',
    activeBG: '#06AEBA',
  },
  drawer: {
    headerTitle: '#0f100d',
    closeIcon: '#91938e',
  },
  table: {
    headerBackground: '#fff',
    headerColor: '#50649c',
    color: '#7286a2',
  },
};
module.exports = theme;
